(function() {
    'use strict';

    angular.module('stats.constants', [])
        .constant('statsPermissionsConst', {
            view: {
                value: 'view_stats',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu statystyk!'
            },
            productionLogs: {
                value: 'view_production_log',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu logów produkcyjnych!'
            }
        });
})();
